import { FC } from 'react'
import { Icon } from '@mch-group/uikit-components'
import styled from 'styled-components'
import Text from '@components/Text'

interface IPressAccCompleteMessage {
  mpapd_complete_profile: string
}

const CompleteMessage: FC<IPressAccCompleteMessage> = ({ mpapd_complete_profile }) => (
  <StyledMessage className='p-7'>
    <i className='line' />
    <Icon name='warning' color='var(--bs-mch-light-alert)' />
    <Text forwardedAs='div' isHtml className='text-medium'>
      {mpapd_complete_profile}
    </Text>
  </StyledMessage>
)

const StyledMessage = styled.div`
  display: flex;
  border: 2px solid var(--bs-mch-gray-200);
  border-radius: 2px;
  position: relative;
  align-items: center;

  .line {
    position: absolute;
    display: block;
    width: 4px;
    height: calc(100% + 4px);
    background: var(--bs-mch-light-alert);
    z-index: 1;
    top: -2px;
    left: -2px;
    border: none;
    border-radius: 2px 0 0 2px;
  }

  p:last-child {
    padding-bottom: 0;
    margin-bottom: 0;
  }

  svg {
    margin-right: 16px;
    flex-shrink: 0;
  }
`

export default CompleteMessage
